import React from 'react';
import { Users, Lightbulb, Heart, TrendingUp } from 'lucide-react';
export const WhyChooseUs = () => {
  const benefits = [{
    title: 'Full Journey Support',
    description: 'We stay with you from concept to success, providing continuous expertise and guidance.',
    icon: <Users className="w-6 h-6 text-[#00E5FF]" data-id="element-198" />
  }, {
    title: 'Next-World Thinking',
    description: "Our forward-thinking approach ensures your app is built for today's needs and tomorrow's innovations.",
    icon: <Lightbulb className="w-6 h-6 text-[#B721FF]" data-id="element-199" />
  }, {
    title: 'User-First Design',
    description: 'We create experiences that users love, focusing on intuitive interfaces and emotional connections.',
    icon: <Heart className="w-6 h-6 text-[#00E5FF]" data-id="element-200" />
  }, {
    title: 'Growth Focused',
    description: "Every decision is made with your app's market success and user acquisition in mind.",
    icon: <TrendingUp className="w-6 h-6 text-[#B721FF]" data-id="element-201" />
  }];
  return <section id="why-us" className="relative py-20 w-full overflow-hidden bg-[#080910]" data-id="element-202">
      {/* Background elements */}
      <div className="absolute inset-0 z-0" data-id="element-203">
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-[#00E5FF]/5 rounded-full blur-[150px]" data-id="element-204"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-[#B721FF]/5 rounded-full blur-[150px]" data-id="element-205"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold font-['Orbitron'] mb-4" data-id="element-208">
            Why{' '}
            <span className="bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-209">
              Choose Us
            </span>
          </h2>
          <p className="text-lg text-[#F5F5F5]/70 max-w-2xl mx-auto" data-id="element-210">
            We don't just build apps — we craft digital experiences that define
            the future.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-211">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#0B0C10] border border-[#F5F5F5]/10 rounded-xl p-6 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg hover:shadow-[#00E5FF]/10" data-id="element-212">
              <div className="mb-5 p-3 rounded-lg bg-gradient-to-br from-[#0B0C10] to-[#121318] border border-[#F5F5F5]/5 inline-block" data-id="element-213">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold font-['Orbitron'] mb-3" data-id="element-214">
                {benefit.title}
              </h3>
              <p className="text-[#F5F5F5]/70" data-id="element-215">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};